import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistroPorPaginaItinerarioEmbarque from '../../actions/itinerario/alterarRegistrosPorPaginaItinerarioEmbarque'
import determinarPorParginaItinerarioEmbarque from '../../actions/itinerario/determinarPaginaAtualItinerarioEmbarque'

export class PaginacaoitinerarioEmbarque extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPorParginaItinerarioEmbarque}
      alterarRegistrosPorPagina={this.props.alterarRegistroPorPaginaItinerarioEmbarque}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistroPorPaginaItinerarioEmbarque,
    determinarPorParginaItinerarioEmbarque
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualItinerarioEmbarque,
    total: state.itinerarios.total,
    registrosPorPagina: state.registrosPorPaginaAtualItinerarioEmbarque
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoitinerarioEmbarque)
